<template>
  <div @mouseover="active_affix" @mouseleave="hide_affix">
    <a-row type="flex">
      <a-col :span="2"></a-col>
      <a-col :span="5" class="enterprise_page_title">Portfolio</a-col>
      <a-col :span="17"></a-col>
    </a-row>
    <div style="padding: 0 8.4vw">
      <a-row type="flex">
        <a-col v-for="(item, index) in enterprise.items" :key="index" class="enterprise_item" @click="showmodal(index)">
          <img :src="item.trademark">
          <p style="color: grey; margin-top: 3vh; font-size: 16px">{{ item.name_en }}</p>
        </a-col>
        <a-col v-for="(item, index) in enterprise.perished" :key="index" class="enterprise_item">
          <img :src="item.trademark">
          <p style="color: grey; margin-top: 3vh; font-size: 16px">{{ item.name_en }}</p>
        </a-col>
      </a-row>
    </div>
    <a-affix v-if="affix.visible" :offset-bottom="0" style="width: 2vw;padding-left: 94vw;padding-bottom: 10vh">
      <h3 id="a" class="enterprise_affix" @click="jump('a')" @mouseover="remind('a')">A</h3>
      <h3 id="b" class="enterprise_affix" @click="jump('b')" @mouseover="remind('b')">B</h3>
      <h3 id="c" class="enterprise_affix" @click="jump('c')" @mouseover="remind('c')">C</h3>
      <h3 id="d" class="enterprise_affix" @click="jump('d')" @mouseover="remind('d')">D</h3>
      <h3 id="e" class="enterprise_affix" @click="jump('e')" @mouseover="remind('e')">E</h3>
      <h3 id="f" class="enterprise_affix" @click="jump('f')" @mouseover="remind('f')">F</h3>
      <h3 id="g" class="enterprise_affix" @click="jump('g')" @mouseover="remind('g')">G</h3>
      <h3 id="h" class="enterprise_affix" @click="jump('h')" @mouseover="remind('h')">H</h3>
      <h3 id="i" class="enterprise_affix" @click="jump('i')" @mouseover="remind('i')">I</h3>
      <h3 id="j" class="enterprise_affix" @click="jump('j')" @mouseover="remind('j')">J</h3>
      <h3 id="k" class="enterprise_affix" @click="jump('k')" @mouseover="remind('k')">K</h3>
      <h3 id="l" class="enterprise_affix" @click="jump('l')" @mouseover="remind('l')">L</h3>
      <h3 id="m" class="enterprise_affix" @click="jump('m')" @mouseover="remind('m')">M</h3>
      <h3 id="n" class="enterprise_affix" @click="jump('n')" @mouseover="remind('n')">N</h3>
      <h3 id="o" class="enterprise_affix" @click="jump('o')" @mouseover="remind('o')">O</h3>
      <h3 id="p" class="enterprise_affix" @click="jump('p')" @mouseover="remind('p')">P</h3>
      <h3 id="q" class="enterprise_affix" @click="jump('q')" @mouseover="remind('q')">Q</h3>
      <h3 id="r" class="enterprise_affix" @click="jump('r')" @mouseover="remind('r')">R</h3>
      <h3 id="s" class="enterprise_affix" @click="jump('s')" @mouseover="remind('s')">S</h3>
      <h3 id="t" class="enterprise_affix" @click="jump('t')" @mouseover="remind('t')">T</h3>
      <h3 id="u" class="enterprise_affix" @click="jump('u')" @mouseover="remind('u')">U</h3>
      <h3 id="v" class="enterprise_affix" @click="jump('v')" @mouseover="remind('v')">V</h3>
      <h3 id="w" class="enterprise_affix" @click="jump('w')" @mouseover="remind('w')">W</h3>
      <h3 id="x" class="enterprise_affix" @click="jump('x')" @mouseover="remind('x')">X</h3>
      <h3 id="y" class="enterprise_affix" @click="jump('y')" @mouseover="remind('y')">Y</h3>
      <h3 id="z" class="enterprise_affix" @click="jump('z')" @mouseover="remind('z')">Z</h3>
    </a-affix>
    <a-modal v-model:visible="modal.visible" @click="close"
             :centered="true" :footer="null" :width="'80vw'"
             :destroyOnClose="true" :bodyStyle="{padding: 0}">
      <div v-if="modal.picture_owner" class="enterprise_item_detail">
        <a-row>
          <a-col :span="12" style="display: flex">
            <img :src="modal.picture_owner">
            <div style="z-index: 2;position: absolute; padding-top: 40vh; padding-left: 3vh">
              <p style="margin: 0; font-size: 28px">{{ modal.name }}</p>
              <p>——</p>
              <p style="font-size: 28px">{{ modal.owner }}</p>
            </div>
          </a-col>
          <a-col :span="12" style="height: 40vw;">
            <a-row style="height: 30vw; display: flex; align-items: center">
              <div style="text-align: center">
                <a-row style="padding-top: 5vh">
                  <p style="font-size: 32px;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
                    {{ modal.name }}</p>
                  <LinkOutlined v-if="modal.site" @click="tosite(modal.site)"
                                style="font-size: 26px;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
                </a-row>
                <p style="color: dimgrey">—————</p>
                <ul style="text-align: center; width: 30vw; margin: 0 5vw;max-height: 15vw;overflow-y: scroll">
                  <li v-for="(item, index) in modal.introduction" :key="index"
                      style="text-align: left;font-size: 16px; margin-bottom: 1em">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </a-row>
            <a-row style="height: 10vw;text-align: center">
              <img :src="modal.trademark"
                   style="width:auto; max-height:10vw;filter: brightness(100%);">
            </a-row>
          </a-col>
        </a-row>
      </div>
      <div v-else style="height: 40vw;">
        <div style="height: 30vw;display: flex;align-items: center;text-align: center;">
          <div style="width: 80vw">
            <a-row style="padding-top: 5vh;">
              <p style="font-size: 42px;color: black;margin-bottom: 0;padding-right: 1vw;display: inline">
                {{ modal.name }}</p>
              <LinkOutlined v-if="modal.site" @click="tosite(modal.site)"
                            style="font-size: 26px;text-align: left; color: cornflowerblue;padding-left: 0.5vw;display: inline"/>
            </a-row>
            <p style="color: dimgrey">—————</p>

            <ul style="text-align: center; width: 60vw; margin: 0 10vw;overflow-x: hidden; max-height: 35vh;font-size: 16px">
              <li v-for="(item, index) in modal.introduction" :key="index"
                  style="text-align: left; font-size: 16px; margin-bottom: 1em">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div style="height: 10vw;text-align: center">
          <img :src="modal.trademark"
               style="width:auto; max-height:10vw;filter: brightness(100%);">
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios'
import {reactive, onMounted} from 'vue'
import {LinkOutlined} from "@ant-design/icons-vue/"

export default {
  name: 'Enterprise_page_en',
  components: {LinkOutlined},
  setup() {
    const enterprise = reactive({
      items: [],
      perished: [],
      pointers: [['a', 0], ['b', 0], ['c', 0], ['d', 0], ['e', 0], ['f', 0], ['g', 0], ['h', 0], ['i', 0], ['j', 0], ['k', 0], ['l', 0],
        ['m', 0], ['n', 0], ['o', 0], ['p', 0], ['q', 0], ['r', 0], ['s', 0], ['t', 0], ['u', 0], ['v', 0], ['w', 0], ['x', 0], ['y', 0], ['z', 0]],

    })
    let modal = reactive({
      name: '',
      site: '',
      owner: '',
      introduction: '',
      picture_owner: '',
      trademark: '',
      visible: false,
    })
    const active_affix = () => {
      affix.visible = true
    }
    const hide_affix = () => {
      affix.visible = false
    }
    let affix = reactive({visible: false})

    const showmodal = (index) => {
      modal.name = enterprise.items[index]['name_en']
      modal.site = enterprise.items[index]['site']
      modal.owner = enterprise.items[index]['owner_en']
      modal.introduction = enterprise.items[index]['introduction_en']
      modal.picture_owner = enterprise.items[index]['picture_owner']
      modal.trademark = enterprise.items[index]['trademark']
      modal.visible = true
    }
    const close = (e) => {
      modal.visible = false
    }
    const tosite = (site) => {
      window.open(site)
    }
    const jump = (pointer) => {
      let target = 0
      for (let i of enterprise.pointers) {
        if (i[0] === pointer) {
          target = i[1]
          break
        }
      }
      document.documentElement.scrollTo(
          {
            top: window.innerHeight * (1 + 0.25 * target),
            behavior: "smooth",
          }
      )
    }
    const remind = (target) => {
      document.getElementById(target).classList.add("animate__heartBeat")
      setTimeout(function () {
        document.getElementById(target).classList.remove("animate__heartBeat")
      }, 1000)
    }

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/enterprise')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i]["status"] === 'perished') {
                enterprise.perished.push(res.data[i])
              } else {
                enterprise.items.push(res.data[i])
              }
            }
            enterprise.items.sort(function (a, b) {
              return a.name_en.localeCompare(b.name_en)
            })
            enterprise.perished.sort(function (a, b) {
              return a.name_en.localeCompare(b.name_en)
            })
            //计算各字母开头的公司数量
            let temp = []
            for (let i = 0; i < enterprise.items.length; i++) {
              temp.push(enterprise.items[i].name.slice(0, 1).toLowerCase())
            }
            for (let i = 1; i < enterprise.pointers.length; i++) {
              if (temp.indexOf(enterprise.pointers[i][0]) === -1) {
                enterprise.pointers[i][1] = enterprise.pointers[i - 1][1]
              } else {
                enterprise.pointers[i][1] = Math.floor(temp.indexOf(enterprise.pointers[i][0]) / 4) // pointer内指向对应行数
              }
            }
            //根据显示要求对公司信息进行处理
            for (let i = 0; i < enterprise.items.length; i++) {
              enterprise.items[i]["trademark"] = 'https://sig-china.com' + enterprise.items[i]["trademark"]
              if (enterprise.items[i]["picture_owner"]) {
                enterprise.items[i]["picture_owner"] = 'https://sig-china.com' + enterprise.items[i]["picture_owner"]
              }
              if (enterprise.items[i]["introduction_en"].indexOf('\r\n') !== -1) {
                let temp = enterprise.items[i]["introduction_en"]
                enterprise.items[i]["introduction_en"] = []
                while (temp.indexOf('\r\n') !== -1) {
                  let pointer = temp.indexOf('\r\n')
                  enterprise.items[i]["introduction_en"].push(temp.slice(0, pointer))
                  temp = temp.slice(pointer + 2,)
                }
                enterprise.items[i]["introduction_en"].push(temp)
              } else {
                enterprise.items[i]["introduction_en"] = [enterprise.items[i]["introduction_en"]]
              }
            }
            for (let i = 0; i < enterprise.perished.length; i++) {
              enterprise.perished[i]["trademark"] = 'https://sig-china.com' + enterprise.perished[i]["trademark"]
            }
          })
    })
    return {enterprise, modal, showmodal, close, tosite, jump, affix, active_affix, hide_affix, remind}
  },
}
</script>

<style scoped>
.enterprise_item {
  border-style: solid;
  border-width: 1px;
  border-color: #f8f8f8;
  width: 20.8vw;
  height: 25vh;
}

.enterprise_item img {
  padding-top: 4vh;
  width: 16vw;
  height: 14vh;
  max-width: 25vw;
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
    object-fit: cover;

}

.enterprise_item img:hover {
  -webkit-filter: inherit;
  -moz-filter: inherit;
  -ms-filter: inherit;
  -o-filter: inherit;
  filter: inherit;
  filter: inherit;
}

.enterprise_page_title {
  background: #2f54eb;
  color: white;
  font-size: 18px;
  text-align: left;
  line-height: 40px;
  padding-left: 2vh;
  text-indent: 2em;
}

.enterprise_item_detail img {
  width: 40vw;
  height: 40vw;
  max-width: 40vw;
  filter: brightness(80%)
}

.enterprise_affix {
  color: grey;
  font-size: 1.6vh;
  width: 2vw;
  margin-bottom: 0;
}

.enterprise_affix:hover {
  cursor: pointer;
}
</style>
